// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2a015fc5","455":"37285ae1"}[chunkId] + ".chunk.js";
};